import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'We use cookies',
    description:
      'We use cookies and similar technologies to power this experience. Strictly necessary cookies are always active. You can review and control optional cookies by purpose in cookie settings, and change your choice at any time.',
    allow_label: 'Accept all cookies',
    reject_label: 'Only strictly necessary',
    settings_label: 'Cookie settings',
    policy_link_label: 'Privacy and cookie policy',
    categories_label: 'Categories',
    always_on_label: 'Always on',
    required_label: 'Required',
    save_preferences_label: 'Save preferences',
    close_label: 'Close',
    allow_all_optional_categories_label: 'Allow all optional categories',
    save_error: 'We could not save your privacy choice. Please try again.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strictly Necessary',
      purpose:
        'Required to deliver this experience. Covers sign-in, security, application state, feature configuration, and remembering your cookie choice. These cannot be turned off.'
    },
    analytics: {
      name: 'Analytics',
      purpose:
        'Measures how visitors use this experience, including page views, session activity, heatmaps, and interaction replay, so performance can be understood and improved.'
    },
    marketing: {
      name: 'Marketing',
      purpose:
        'Supports advertising and marketing chosen by the organizer, including ad pixels, retargeting, campaign attribution, and social widgets.'
    }
  }
};

export default locale;
